module.exports = __webpack_public_path__ + "img/DK24255689.1f1c8636.png";